import "@fontsource/playfair-display/600.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PublicConfigProvider } from "./lib/public-config";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PublicConfigProvider>
        <App />
      </PublicConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
